import React, { useState } from "react";
import { Route, Switch } from "react-router-dom";
import { Layout, message } from "antd";
import SidebarWrapper from "../../components/sidebar/sidebarWrapper";
import HeaderWrapper from "../../components/header/headerWrapper";
import FooterWrapper from "../../components/footer/footerWrapper";
import Services from "./Services";
import Refund from "../shell/refund";

import SubServices from "./SubServices";
import PriceDetails from "./PricesDetails";

const { Content } = Layout;

const Shell = () => {
  const [collapsed, toggleCollapsed] = useState(false);
  return (
    <div>
      <Layout>
        <SidebarWrapper collapsed={collapsed} toggleCollapsed={toggleCollapsed} />

        <Layout>
          <HeaderWrapper collapsed={collapsed} toggleCollapsed={toggleCollapsed} />

          <Content style={{ padding: 48, backgroundColor: "#fff" }}>
            <Switch>
              <Route exact path="/" component={Services}></Route>
              {/* <Route exact path="/refund" component={Refund}></Route> */}

              <Route exact path="/services" component={Services}></Route>
              <Route exact path="/customers/:category/:id" component={SubServices} />
              <Route exact path="/price/:id/:category/:index" component={PriceDetails} />
            </Switch>
          </Content>

          <FooterWrapper />
        </Layout>
      </Layout>
    </div>
  );
};

export default Shell;

const AccessDenied = () => {
  return (
    <div>
      <h1>You cannot access this functionality due to insufficient rights.</h1>
    </div>
  );
};
